<!--走进资环/公司概况-->
<template class="carbon">
  <div style="font-family: Alibaba">
    <!--CP端-->
    <div class="PC_box">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component class="walkinto" :is='components.tail'></component>
        </keep-alive>
      </div>

      <!--导航图-->
      <div>
        <el-carousel height="25vw" class='carousel_class'>
          <el-carousel-item v-for='item in walkintoList' :key='item.id'>
<!--            <div @click='jump(item)'>-->
              <el-image
                style="width: 100%;height: 25vw"
                v-if='item.fullPathUrl != null'
                :src='item.fullPathUrl'
              />
<!--            </div>-->
          </el-carousel-item>
        </el-carousel>
      </div>
      <!--公司介绍-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameOne }}
          </h1>
          <p>{{ enNameOne }}</p>
        </div>
      </div>
      <!--公司介绍-->
      <div class="box-width company">
        <h2>{{ companyProfile.title }}</h2>
        <div v-html="companyProfile.content" class="htmlImgSize"></div>
      </div>

      <!--公司宣传片标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameTwo }}
          </h1>
          <p>{{ enNameTwo }}</p>
        </div>
      </div>
      <!--公司宣传片-->
      <el-row  :span="24" class="box-width video">
        <el-col :md="12" :sm="12" :xs="24">
          <div>
            <!-- 使用视频插件 -->
            <video
              controls
              :src="corporateVideos.fullPathUrl != null ? corporateVideos.fullPathUrl : ''"
              style="width: 100%; height: auto;"></video>
          </div>
        </el-col>
        <el-col :md="12" :sm="24" :xs="24">
          <div class="video_text">
            <div v-html="corporateVideos.content" class="htmlImgSize"></div>
          </div>
        </el-col>
      </el-row>

      <!--合作伙伴标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameThree }}
          </h1>
          <p>{{ enNameThree }}</p>
        </div>
      </div>
      <!--合作伙伴-->
      <el-row  :gutter="20" class="box-width">
        <el-col :md="6" :sm="8" :xs="12" v-for="item in cooperativePartner" :key="item.id">
          <div class="partner">
            <el-image class="partner_img" :src="item.fullPathUrl"></el-image>
          </div>
        </el-col>
      </el-row>

      <!--插入尾部-->
      <div>
        <keep-alive>
          <component  :is='components.tail1'></component>
        </keep-alive>
      </div>
    </div>

    <!--手机端-->
    <div class="mobile_box product">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class='paddingS'>
        <!--占位div-->
        <div style='height: 72px'></div>

        <!--主图-->
        <div class="main_img">
          <el-carousel height="200px" class='carousel_class'>
            <el-carousel-item v-for='item in walkintoList' :key='item.id'>
              <div>
                <el-image
                  :fit='fit'
                  v-if='item.fullPathUrl != null'
                  :src='item.fullPathUrl'
                />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <!--公司介绍-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameOne }}
                <span>{{ enNameOne }}</span>
              </h1>
            </div>
            <!--内容-->
            <div>
              <div v-html="companyProfile.content" class="htmlImgSize"></div>
            </div>
          </div>
        </div>

        <!--公司宣传片-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameTwo }}
                <span>{{ enNameTwo }}</span>
              </h1>
            </div>
            <!--视频-->
            <div class="videos">
              <video
                controls
                :src="corporateVideos.fullPathUrl != null ? corporateVideos.fullPathUrl : ''"
                style="width: 100%; height: auto;"></video>
            </div>
            <div class="video_text">
              <div v-html="corporateVideos.content" class="htmlImgSize"></div>
            </div>
          </div>
        </div>

        <!--插入尾部-->
        <div>
          <keep-alive>
            <component  :is='components.tail1'></component>
          </keep-alive>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import header from '../components/header.vue'
import footer from '../components/footer.vue'
import {
  findBanner,
  findEnName,
  findWalkintoOne,
  findWalkintoTwo,
  findWalkintoThree
} from '@api/zh'

export default {
  data () {
    return {
      tabId: null,
      components: {
        tail: header,
        tail1: footer
      },
      companyProfile: {},
      corporateVideos: {},
      cooperativePartner: [],
      enNameOne: '',
      enNameTwo: '',
      enNameThree: '',
      cnNameOne: '',
      cnNameTwo: '',
      cnNameThree: '',
      activeName: 'second',
      fit: 'cover',
      url2: require('@assets/images/index/changjing.jpg'),
      src: require('@assets/images/index/baidu.png'),
      src1: require('@assets/images/index/guge.png'),
      honorUrc: require('@assets/images/aboutZh/zs3.png'),
      walkintoList: [],
      carouselParams: {
        type: 1
      }
    }
  },
  created () {
    this.tabId = this.$route.query.tabId
    this.selectBanner()
    this.selectEnName()
  },
  mounted () {
  },
  methods: {
    jump (raw) {
      if (raw.newsId === undefined || raw.newsId === '' || raw.newsId === null) {
      } else {
        this.$router.push({
          path: '/textContent',
          query: {
            id: raw.newsId,
            type: 2
          }
        })
      }
    },
    /** 轮播图 */
    selectBanner () {
      let that = this
      findBanner(this.tabId).then(res => {
        that.walkintoList = res.data
      })
    },
    /** 查询英文名称 */
    selectEnName () {
      let that = this
      findEnName(this.tabId).then(res => {
        let data = res.data
        that.enNameOne = data[0].enName
        that.cnNameOne = data[0].cnName
        that.selectWalkintoOne(data[0].id)

        that.enNameTwo = data[1].enName
        that.cnNameTwo = data[1].cnName
        that.selectWalkintoTwo(data[1].id)

        that.enNameThree = data[2].enName
        that.cnNameThree = data[2].cnName
        that.selectWalkintoThree(data[2].id)
      }).catch(error => {
        console.error('Error fetching English names:', error)
      })
    },
    async selectWalkintoOne (enNameId) {
      let that = this
      await findWalkintoOne(enNameId).then(res => {
        that.companyProfile = res.data
      })
    },
    async selectWalkintoTwo (enNameId) {
      let that = this
      await findWalkintoTwo(enNameId).then(res => {
        that.corporateVideos = res.data
      })
    },
    async selectWalkintoThree (enNameId) {
      let that = this
      await findWalkintoThree(enNameId).then(res => {
        that.cooperativePartner = res.data
      })
    },
    /** tab */
    handleClick (tab, event) {
      console.log(tab, event)
    }
  }
}
</script>

<style scoped>
::v-deep .htmlImgSize img{
  max-width: 100%;
  height: auto;
}

/* 添加以下CSS代码 */
.partner_img {
  transition: transform 0.2s ease;
}

.partner_img:hover {
  transform: scale(1.1); /* 放大1.1倍 */
}
</style>
